/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import PropTypes from "prop-types";
import { Modal } from "vr-react-components";
import EngineSelectionModal from "./EngineSelectionModal";
import EngineSelectionOverview from "./EnginesSelectionOverview";
import { useDispatch, useSelector } from "react-redux";
import { setOpenedModal } from "../../store/slice/roomSlice";

const EnginesSelectionWidget = ({ position, width, height, ...otherAttributes }) => {
    const canModify = useSelector((state) => state.private.device.canModify);
    const openedModal = useSelector((state) => state.room.openedModal);

    const dispatch = useDispatch();

    const handleSetIsOpened = (id) => dispatch(setOpenedModal(id));

    return (
        <Modal
            id={"engines-modal"}
            position={position}
            width={width}
            height={height}
            openedPanelDimension={1.15}
            openedPosition="0 1.65 -0.9"
            aframeClasses={canModify ? "collidable" : ""}
            OpenedComponent={EngineSelectionModal}
            ClosedComponent={EngineSelectionOverview}
            openedModal={openedModal}
            onOpen={handleSetIsOpened}
            overlay
            {...otherAttributes}
        />
    );
}

EnginesSelectionWidget.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    position: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default EnginesSelectionWidget;